<template>
  <div class="login-container">
    <BattleHeader title="墨客争霸" @back="goBack" />
    
    <div class="login-form">
      <div class="input-group">
        <span class="country-code">+86</span>
        <input 
          type="tel" 
          placeholder="请输入手机号" 
          v-model="phoneNumber"
          @input="onPhoneInput"
          maxlength="11"
          class="phone-input"
        />
      </div>
      
      <!-- 滑动验证码区域 -->
      <div class="slide-verify-container">
        <SliderCaptcha 
          v-if="isPhoneValid"
          @success="onSuccess"
          @fail="onFail"
        />
        <div v-else-if="phoneNumber && !isPhoneValid" class="captcha-placeholder">
          请输入正确的手机号以启用滑动验证
        </div>
      </div>
      
      <!-- 短信验证码区域 -->
      <div v-if="isVerified" class="input-group">
        <input 
          type="text" 
          placeholder="请输入短信验证码" 
          v-model="smsCode"
          maxlength="6"
          class="verification-input"
        />
        <button 
          :disabled="!canResendCode" 
          @click="resendCode"
          class="resend-btn"
        >
          {{ countdown > 0 ? `${countdown}秒后重发` : '发送短信' }}
        </button>
      </div>
      
      <button 
        class="login-btn" 
        @click="handleLogin"
        :disabled="!phoneNumber || !isVerified || !smsCode"
      >
        注册/登录
      </button>
    </div>
    <div class="company-info">
      北京墨趣科技有限公司
    </div>
  </div>
</template>

<script>
import { sendSmsCode } from '@/api/api'
import SliderCaptcha from '@/components/SliderCaptcha.vue'
import { initAuthState, login, globalAuthState } from '../utils/auth';
import { alert } from '@/utils/modal';
import BattleHeader from '@/components/BattleHeader.vue'


export default {
  name: 'LoginPage',
  components: {
    SliderCaptcha,
    BattleHeader
  },
  data() {
    return {
      isBrowserEnv: true, // 始终为浏览器环境
      isLogin: globalAuthState.isLogin,
      phoneNumber: '',
      isVerified: false,
      smsCode: '',
      countdown: 0,
      canResendCode: true,
      // 防伪码相关状态
      securityCode: '',
      userSecurityInput: '',
      securityCodeImage: ''
    }
  },
  computed: {
    isPhoneValid() {
      return /^1[3-9]\d{9}$/.test(this.phoneNumber);
    }
  },
  mounted() {
    initAuthState();
    this.isLogin = globalAuthState.isLogin;
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/'})
    },
    
    async onPhoneInput() {
      // 当用户输入手机号时，如果格式不正确则给出提示
      if (this.phoneNumber && !this.isPhoneValid) {
        // 只在用户输入了内容但格式不正确时提示
        if (this.phoneNumber.length === 11) {
          await alert('请输入正确的手机号');
        }
      }
      // 如果手机号变为空或格式不正确，则重置验证状态
      if (!this.isPhoneValid) {
        this.isVerified = false;
      }
    },
    
    // 倒计时方法
    startCountdown() {
      this.countdown = 60;
      this.canResendCode = false;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
          this.canResendCode = true;
        }
      }, 1000);
    },
    
    // 重新发送验证码
    resendCode() {
      this.sendVerificationCode();
      this.startCountdown();
    },
    
    // 滑动验证码成功回调
    onSuccess() {
      this.isVerified = true
      console.log('滑动验证成功')
      // 验证成功后不自动发送验证码，等待用户点击发送
    },
    
    // 滑动验证码失败回调
    onFail() {
      this.isVerified = false
      console.log('滑动验证失败')
    },
    
    // 发送验证码
    async sendVerificationCode() {
      // 先验证手机号格式
      if (!/^1[3-9]\d{9}$/.test(this.phoneNumber)) {
        await alert('请输入正确的手机号')
        return
      }
      console.log('发送验证码到手机号:', this.phoneNumber)

      const jsonStr = JSON.stringify({
        code: 86,
        mobile: this.phoneNumber,
        event: 'mobilelogin'
      })
      
      // 调用发送短信验证码接口
      sendSmsCode({
        sign: this.$md5('moquSms' + jsonStr),
        data: jsonStr,
        mobile: this.phoneNumber,
        event: 'mobilelogin'
      }).then(async response => {
        if (response.code === 1) {
          // 验证码发送成功
          await alert('验证码已发送，请注意查收')
        } else {
          // 验证码发送失败，提示用户
          await alert('验证码发送失败，请稍后重试')
        }
      }).catch(async () => {
        // 网络错误等异常情况，提示用户
        await alert('网络错误，请稍后重试')
      })
    },
    async handleLogin() {
      // 验证输入
      if (!/^1[3-9]\d{9}$/.test(this.phoneNumber)) {
        await alert('请输入正确的手机号')
        return
      }
      
      // 检查是否已完成滑动验证
      if (!this.isVerified) {
        await alert('请先完成滑动验证')
        return
      }
      
      // 检查是否已输入短信验证码
      if (!this.smsCode) {
        await alert('请输入短信验证码')
        return
      }
      
      // 使用现有的登录方法
      login({
        mobile: this.phoneNumber,
        captcha: this.smsCode
      }, this.$router)
      
      // 如果是在浏览器环境中，同时更新JSBridge的用户信息
      if (window.jsBridge && !window.jsBridge.isInApp) {
        // 这里需要获取登录后的用户信息，可以通过全局状态或其他方式获取
        // 暂时使用模拟数据，实际应用中应从登录响应中获取真实数据
        // const mockUserInfo = {
        //   userId: 'user_' + Date.now(),
        //   mobile: this.phoneNumber,
        //   nickname: '用户' + this.phoneNumber.slice(-4)
        // };
        // window.jsBridge.setUserInfo(mockUserInfo);
      }
    }
  }
}
</script>

<style scoped>
.login-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.login-form {
  flex: 1;
  padding: calc(var(--battle-header-height) + 20px) 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.input-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 8px;
  padding: 0 15px;
}

.country-code {
  color: #333;
  margin-right: 10px;
  font-size: 16px;
}

.phone-input,
.verification-input {
  flex: 1;
  border: none;
  outline: none;
  padding: 15px 0;
  font-size: 16px;
}

.resend-btn {
  background-color: #D54D24;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 5px 10px;
  font-size: 14px;
  cursor: pointer;
}

.resend-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.slide-verify-container {
  margin-bottom: 20px;
}

.captcha-placeholder {
  text-align: center;
  padding: 20px;
  background-color: #f0f0f0;
  border-radius: 8px;
  color: #666;
  font-size: 14px;
}

.login-btn {
  background-color: #D54D24;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 15px;
  font-size: 16px;
  cursor: pointer;
  margin-top: 20px;
}

.login-btn:disabled {
  background-color: #D54D24;
  cursor: not-allowed;
}

.company-info {
  text-align: center;
  color: #999;
  font-size: 12px;
  padding: 20px;
}


</style>
